import { render, staticRenderFns } from "./ProductBuyButton.vue?vue&type=template&id=0b5b395b&scoped=true"
import script from "./ProductBuyButton.vue?vue&type=script&lang=js"
export * from "./ProductBuyButton.vue?vue&type=script&lang=js"
import style0 from "./ProductBuyButton.vue?vue&type=style&index=0&id=0b5b395b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5b395b",
  null
  
)

export default component.exports